<script lang="ts" setup>
import { onMounted, onUnmounted } from "vue";

import { useVersionStore } from "@/App/version/version.store";
import { windowsService } from "@/App/services/windowsService";

const versionStore = useVersionStore();

let timeout: NodeJS.Timeout;

const check = async (): Promise<void> => {
  // for some reason the testing version store have all actions undefined
  // it works just fine for the cases store...
  // it is not about options versus setup because I tried both
  // so I added this ".?" here
  // the component test is not all I wanted it to be but it cost me a couple of hours already
  // I will have to create a couple of isolated test files to understand what is going on, eventually
  await versionStore.checkForLatestVersion?.();

  timeout = setTimeout(check, 60 * 1000);
};

onMounted((): void => {
  check();
});

onUnmounted(() => {
  clearTimeout(timeout);
});
</script>

<template>
  <template v-if="!versionStore.isLatest">
    <button class="update-available" @click="windowsService.reloadPage">
      <div class="main-content update-available__content">
        <span class="update-available__message" data-testid="update-available-message"
          >New version available. Click this message to reload and update.</span
        >
      </div>
    </button>
  </template>
</template>

<style>
.update-available {
  all: unset;
  background: lightyellow;
  display: block;
  width: 100%;
}

.update-available:focus:not(:focus-visible):not(:hover) {
  background: lightyellow;
}

.update-available:focus,
.update-available:hover {
  background: #ffadff;
}

.update-available:active {
  background: #ff7aff;
}

.update-available__content {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}

.update-available__message {
  margin-left: 0.25rem;
}
</style>
